(function () {
  'use strict';
  if (window.textualSizeSwatchesLoaded) return;
  window.textualSizeSwatchesLoaded = true;
  function sync(item) {
    var input = item.querySelector('[data-single-option-selector]');
    if (input) input.disabled = item.classList.contains('product-swatch__item--soldout');
  }
  function initialize(scope) {
    scope.querySelectorAll('.product-swatch--size [data-swatch-item-selector]').forEach(function (item) {
      if (item.dataset.sizeAvailabilityReady) return;
      item.dataset.sizeAvailabilityReady = 'true';
      sync(item);
      new MutationObserver(function () { sync(item); }).observe(item, {attributes: true, attributeFilter: ['class']});
    });
  }
  // The theme allows sold-out swatches for stock notifications; sizes must stay disabled.
  document.addEventListener('click', function (event) {
    var item = event.target.closest('.product-swatch--size .product-swatch__item--soldout');
    if (item) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else initialize(document);
})();
